import { useState, useEffect } from 'react';

export default function Timer({ startTime, duration, onExpire }) {
  const [timeRemaining, setTimeRemaining] = useState(duration);

  useEffect(() => {
    if (!startTime) return;

    const interval = setInterval(() => {
      const now = new Date();
      const start = new Date(startTime);
      const elapsed = Math.floor((now - start) / 1000);
      const remaining = Math.max(0, duration - elapsed);

      setTimeRemaining(remaining);

      if (remaining === 0 && onExpire) {
        onExpire();
      }
    }, 100);

    return () => clearInterval(interval);
  }, [startTime, duration, onExpire]);

  // Determine color based on time remaining
  const getColor = () => {
    if (timeRemaining > 10) return '#10b981'; // Green
    if (timeRemaining > 5) return '#eab308'; // Yellow
    return '#ef4444'; // Red
  };

  // Calculate progress (0 to 1)
  const progress = timeRemaining / duration;
  const radius = 56;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div className="fixed top-8 right-8 z-50">
      <div className="relative w-32 h-32">
        <svg className="transform -rotate-90" width="128" height="128">
          {/* Background circle */}
          <circle
            cx="64"
            cy="64"
            r={radius}
            stroke="#ffffff33"
            strokeWidth="8"
            fill="none"
          />
          {/* Progress circle */}
          <circle
            cx="64"
            cy="64"
            r={radius}
            stroke={getColor()}
            strokeWidth="8"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 0.1s linear' }}
          />
        </svg>
        {/* Time display */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-4xl font-bold text-white" style={{ color: getColor() }}>
            {timeRemaining}
          </span>
        </div>
      </div>
    </div>
  );
}
